import { createI18n } from 'vue-i18n'

import { SAVED_LOCALE } from '@/core/constants/localStorageKeys'
import { FALLBACK_LOCALE } from '../constants/locale'

import de from './de'
import en from './en'

const messages = {
  en,
  de,
} as const

const savedLocale = localStorage.getItem(SAVED_LOCALE)

const i18n = createI18n({
  legacy: false,
  locale: savedLocale || FALLBACK_LOCALE, // set default locale
  fallbackLocale: FALLBACK_LOCALE, // set fallback locale
  messages,
})

export default i18n
